export interface MainMenuItemChild {
  name: string;
  iconName: string;
  route?: string;
  requiredPermission?: string;
}

export interface MainMenuItemGroup {
  name: string;
  iconName: string;
  children: MainMenuItemChild[];
}

export const MainMenuComponentItems: MainMenuItemGroup[] = [
  {
    name: 'galaxy',
    iconName: 'planet',
    children: [
      { name: 'Audios', iconName: 'headset', route: '/audios' },
      {
        name: 'Videos',
        iconName: 'movie',
        route: '/videos',
      },
      { name: 'Apps', iconName: 'apps', route: '/apps' },
      { name: 'Images', iconName: 'photo_library', route: '/images' },
      { name: 'Articles', iconName: 'news', route: '/articles' },
      { name: 'Books', iconName: 'menu_book', route: '/books' },
      { name: 'Contents', iconName: 'folder', route: '/contents' },
      { name: 'Carts', iconName: 'shopping_cart', route: '/carts' },
      { name: 'Series', iconName: 'live_tv', route: '/series' },
      { name: 'Live TV', iconName: 'tv', route: '/channels' },
      { name: 'Music', iconName: 'library_music', route: '/music' },
      {
        name: 'Publications',
        iconName: 'library_books',
        route: '/publications',
      },
      {
        name: 'Instant Games',
        iconName: 'sports_esports',
        route: '/instant-games',
      },
      {
        name: 'Quizzes',
        iconName: 'quiz',
        route: '/quizzes',
      },
      // {
      //   name: 'Question Library',
      //   iconName: 'library_books',
      //   route: '/quiz-questions',
      // },
    ],
  },
  {
    name: 'media imports',
    iconName: 'play_circle',
    children: [
      {
        name: 'Import Music',
        iconName: 'save_alt',
        route: '/import-audio-products',
      },
      {
        name: 'Media Explorer',
        iconName: 'folder_match',
        route: '/import-videos',
      },
      {
        name: 'Video Encoding',
        iconName: 'video_settings',
        route: '/encode-videos',
      },
      {
        name: 'Encoding Queues',
        iconName: 'hourglass_bottom',
        route: '/queue-videos',
      },
      {
        name: 'Update Asset',
        iconName: 'perm_media',
        route: '/process-list/asset',
      },
    ],
  },

  {
    name: 'media processes',
    iconName: 'pending_actions',
    children: [
      {
        name: 'AI translation',
        iconName: 'translate',
        route: '/process-list/ai-translation',
      },
      {
        name: 'Subtitle validation',
        iconName: 'fact_check',
        route: '/process-list/subtitle-validation',
      },
      {
        name: 'Transcode',
        iconName: 'movie_edit',
        route: '/process-list/transcode',
      },
      {
        name: 'Article from Video',
        iconName: 'article',
        route: '/process-list/article-from-video',
      },
      {
        name: 'Speech-to-text',
        iconName: 'subtitles',
        route: '/process-list/speech-to-text',
      },
      {
        name: 'Extract audio',
        iconName: 'audio_file',
        route: '/process-list/extract-audio',
      },
      {
        name: 'Restoration',
        iconName: 'restore',
        route: '/process-list/restoration',
      },
      {
        name: 'Delete Asset',
        iconName: 'delete',
        route: '/process-list/delete-asset',
      },
      {
        name: 'Delete Delivery',
        iconName: 'delete',
        route: '/process-list/delete-delivery',
      },
    ],
  },

  {
    name: 'fusio',
    iconName: 'flare',
    children: [
      { name: 'Campaigns', iconName: 'campaign', route: '/campaigns' },
      {
        name: 'Multi campaigns management',
        iconName: 'merge_type',
        route: '/multi-campaigns-management',
      },
      {
        name: 'Search Engine Configs',
        iconName: 'settings',
        route: '/search-engine-configs',
        requiredPermission: 'TELESCOPE_ACCESS',
      },
      { name: 'Rules', iconName: 'sync', route: '/rules' },
    ],
  },

  {
    name: 'admin',
    iconName: 'settings',
    children: [
      { name: 'Artists', iconName: 'person', route: '/artists' },
      { name: 'History', iconName: 'person', route: '/history' },
      { name: 'Import Flows', iconName: 'save_alt', route: '/import-flows' },
      { name: 'Providers', iconName: 'people', route: '/providers' },
      { name: 'Themes', iconName: 'category', route: '/themes' },
      {
        name: 'Rights Map',
        iconName: 'account_tree',
        route: '/rights-map',
        requiredPermission: 'GALAXY_ADMIN',
      },
    ],
  },
];
